module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrRoman.c549197.ttf";